import { Helmet } from 'react-helmet-async'

import NotFoundComponent from '@views/NotFound'

const NotFound = () => {
  return (
    <>
      <Helmet>
        <title>404 - Page Not Found</title>
      </Helmet>
      <NotFoundComponent />
    </>
  )
}

export default NotFound
